import { render, staticRenderFns } from "./document.vue?vue&type=template&id=442c0250&scoped=true&"
import script from "./document.vue?vue&type=script&lang=js&"
export * from "./document.vue?vue&type=script&lang=js&"
import style0 from "./document.vue?vue&type=style&index=0&id=442c0250&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442c0250",
  null
  
)

export default component.exports